export default {
    de: {
        title: 'Bei Ihrem Vorhaben scheint es eine Unterdeckung bei der Finanzierung zu geben',
        subTitle: 'Bitte beantworten Sie die folgenden Fragen und entscheiden sich für eine Lösung.',
        purchasePriceRow: 'Kaufpreis (-anteil)',
        notaryFeeRow: 'Notarkosten usw.',
        taxRow: 'Grunderwerbssteuern',
        brokerFeeRow: 'Makler-Courtage',
        additionalCostRow: 'Bau- / Modernisierungskosten',
        availableEquityRow: 'Eigenkapital',
        loanAmountRow: 'Darlehensbetrag',
        underfundingRow: 'Unterdeckung',
        isBrokerFeePresented: 'Mich unterstützt ein Makler',
        federalStateLabel: 'Ist das Bundesland richtig?',
        federalStateDescription: 'Die angesetzte Maklercourtage variert nach Bundesland',
        federalStateOption_BADEN_WURTTEMBERG: 'Baden-Württemberg',
        federalStateOption_BAYERN: 'Bayern',
        federalStateOption_BERLIN: 'Berlin',
        federalStateOption_BRANDENBURG: 'Brandenburg',
        federalStateOption_BREMEN: 'Bremen',
        federalStateOption_HAMBURG: 'Hamburg',
        federalStateOption_HESSEN: 'Hessen',
        federalStateOption_MECKLENBURG_VORPOMMERN: 'Mecklenburg-Vorpommern',
        federalStateOption_NIEDERSACHSEN: 'Niedersachsen',
        federalStateOption_NORDRHEIN_WESTFALEN: 'Nordrhein-Westfalen',
        federalStateOption_RHEINLAND_PFALZ: 'Rheinland-Pfalz',
        federalStateOption_SAARLAND: 'Saarland',
        federalStateOption_SACHSEN: 'Sachsen',
        federalStateOption_SACHSEN_ANHALT: 'Sachsen-Anhalt',
        federalStateOption_SCHLESWIG_HOLSTEIN: 'Schleswig-Holstein',
        federalStateOption_THURINGEN: 'Thüringen',
        federalStateOption_Empty: 'Bundesland auswählen',
        federalStateIsNotPresented_title: 'Berechnung basieren auf Standardwerten!',
        federalStateIsNotPresented_description: 'Für eine exakte Berechnung, wählen Sie bitte das Bundesland des Objektes.',
        decisionLabel: 'Was möchten Sie tun?',
        decisionIsRequiredValidationMessage: 'Bitte treffen Sie eine Entscheidung bevor Sie fortfahren',
        loanAmountDecision: 'Neuer Kreditbetrag:',
        availableEquityLabel: 'Neues Eigenkapital:',
        decisionOption_addToLoanAmount: 'Kreditbetrag um %amount% erhöhen',
        decisionOptionDescription_addToLoanAmount: 'Neuer Kreditbetrag:',
        decisionOption_addToAvailableEquity: 'Eigenkapital um %amount% erhöhen',
        decisionOptionDescription_addToAvailableEquity: 'Neues Eigenkapital:',
        decisionOption_needAdvice: 'Weiter ohne Änderung',
        decisionOptionDescription_needAdvice: 'Ich benötige eine Beratung',
        submitBtnTitle: 'Weiter',
        submitBtnSubTitle: 'kostenlos und unverbindlich',
    },
};
